import React from 'react';

const Footer = () => {
    return (
        <div>
            <h2 className='bg-black text-white p-20 mt-12 text-center'>Copyright © 2022 - All right reserved by sustainability</h2>
        </div>
    );
};

export default Footer;